import styled from 'styled-components';

const StatItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  p {
    margin-bottom: 0.375rem;
    color: var(--gray-700);
    font-weight: 500;
    font-size: 0.9rem;
  }
`;

export default StatItemContainer;
